// extracted by mini-css-extract-plugin
export var list = "index-module--list--8694d";
export var wrapper = "index-module--wrapper--0171f";